import React from "react";
import ASAPTable from "./CommonTable/ASAPTable";

const ASAP: React.FC = () => {
  return (
    <div className="mx-6">
      <ASAPTable />
    </div>
  );
};
export default ASAP;

